export const ContactUs = () => {
  return (
    <div className="contact-us">
      <h1>Contact Us</h1>
    </div>
  );
};
